module.exports = __webpack_public_path__ + "static/media/logo-app.beb2acce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-app.svg
// module id = 207
// module chunks = 0